import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import {
  Create,
  Form,
  Input,
  TimePicker,
  Select,
  useForm,
  useSelect,
  Edit,
} from "@pankod/refine-antd";

import DatePicker from "components/atoms/datepicker.atom";
import dayjs from "dayjs";
import { useState } from "react";
import { IEvent } from "interfaces";

const { TextArea } = Input;

export const EventEdit: React.FC<IResourceComponentsProps> = () => {

  const { push } = useNavigation();


  const { formProps, saveButtonProps, queryResult } = useForm<IEvent>({
    queryOptions: {
      onSuccess: (data) => {
        handleVisibilityChange(data?.data.visibility);
      }
    }
  });

  const [isPrivate, setIsPrivate] = useState(false);

  const handleVisibilityChange = (value: string) => {
    setIsPrivate(value === "PRIVADO");
    if (value === "PRIVADO") {
      formProps.form?.setFieldsValue({
        name: "PRIVADO",
        description: undefined,
        attendant: undefined,
        attendant_exterior: undefined,
      });
    } else {
      if(formProps.form?.getFieldValue("name") === 'PRIVADO') {
        formProps.form?.setFieldsValue({
          name: "",
        });
      }
    }
  };

  const { selectProps: attendantSelectProps } = useSelect({
    resource: "attendants",
    optionLabel: "name",
    optionValue: "id",
    defaultValue: queryResult?.data?.data.id_attendant || undefined,
  });

  const { selectProps: eventTypeSelectProps } = useSelect({
    resource: "event-types",
    optionLabel: "name",
    optionValue: "id",
    defaultValue: queryResult?.data?.data.id_event_type || undefined,
  });

  const onFinish = async (values: any) => {
    const transformedValues = {
      ...values,
      event_date: typeof values.event_date === "string" ? dayjs(values.event_date) : values.event_date,
      start_time: typeof values.start_time === "string" ? values.start_time : dayjs(values.start_time).format("HH:mm"),
      end_time: typeof values.end_time === "string" ? values.end_time : dayjs(values.end_time).format("HH:mm"),
    };

    await formProps.onFinish?.(transformedValues);

    push("/events", {
      state: { defaultCalendarView: 'timeGridDay' },
    });
  };

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          label="Fecha del evento"
          name="event_date"
          rules={[{ required: true }]}
          getValueProps={(value) => ({
            value: value ? dayjs(value) : "",
          })}
        >
          <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item
          label="Hora de inicio del evento"
          name="start_time"
          rules={[{ required: true }]}
          getValueProps={(value) => {
            const eventDate = formProps.form?.getFieldValue("event_date");
            if (value && typeof value === "string") {
              const combinedDateTime = `${dayjs(eventDate).format("YYYY-MM-DD")}T${value}`;
              return { value: dayjs(combinedDateTime) };
            }
          
            if (value && dayjs.isDayjs(value)) {
              return { value };
            }
          
            return { value: "" };
          }}
          
        >
          <TimePicker style={{ width: "100%" }} format="HH:mm" />
        </Form.Item>
        <Form.Item
          label="Hora de fin del evento"
          name="end_time"
          getValueProps={(value) => {
            const eventDate = formProps.form?.getFieldValue("event_date");
                   
            if (value && typeof value === "string") {
              const combinedDateTime = `${dayjs(eventDate).format("YYYY-MM-DD")}T${value}`;
              return { value: dayjs(combinedDateTime) };
            }
          
            if (value && dayjs.isDayjs(value)) {
              return { value };
            }
          
            return { value: "" };
          }}
        >
          <TimePicker style={{ width: "100%" }} format="HH:mm" />
        </Form.Item>
        <Form.Item
          label="Visibilidad del evento"
          name="visibility"
          rules={[{ required: true }]}
        >
          <Select
            options={[
              { label: "Público", value: "PUBLICO" },
              { label: "Privado", value: "PRIVADO" },
            ]}
            onChange={handleVisibilityChange}
          />
        </Form.Item>
        <Form.Item
          label="¿Asiste Prensa UAS?"
          name="press_visibility"
          rules={[{ required: true }]}
        >
          <Select
            options={[
              { label: "Sí", value: "SI" },
              { label: "No", value: "NO" },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Nombre del evento"
          name="name"
          rules={[{ required: true }]}
        >
          <Input disabled={isPrivate} />
        </Form.Item>
        <Form.Item
          label="Tipo de evento:"
          name="id_event_type"
          rules={[{ required: false }]}
        >
          <Select showSearch {...eventTypeSelectProps} />
        </Form.Item>
        {!isPrivate && (
          <>
            <Form.Item
              label="Descripción"
              name="description"
              rules={[{ required: false }]}
            >
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item
              label="¿Quién atiende?"
              name="id_attendant"
              rules={[{ required: false }]}
            >
              <Select showSearch {...attendantSelectProps} />
            </Form.Item>
            <Form.Item
              label="¿Quiénes asisten?"
              name="attendant_exterior"
              rules={[{ required: false }]}
            >
              <TextArea rows={4} /> 
            </Form.Item>
          </>
        )}
      </Form>
    </Edit>
  );
};
